import SubscriptionForm from './SubscriptionForm';

class TariffForm extends SubscriptionForm {
  constructor(config) {
    super();

    this.type = 'TARIFF';
    this.useTariffName = config?.useTariffName || false;
    this.useTariffDescription = config?.useTariffDescription || false;
    this.useSubscription = false;
  }

  getData() {
    return {
      type: this.type,
      multiBill: this.isMulti,
      description: this.description || null,
      attachment: this.attachment.getData(),
      billTariffs: this.billTariffs.map(tariff => {
        return {
          id: tariff.id,
          name: this.getNameByTariff(tariff),
          description: this.getDescriptionByTariff(tariff),
          amount: tariff.getAmount(this.currency),
          currency: this.currency,
          contentUrl: this.getTariffContentUrl(tariff),
          subscription: this.getSubscriptionByTariff(tariff),
        };
      }),
    };
  }

  getNameByTariff(tariff) {
    if (!this.useTariffName) {
      return null;
    }

    return tariff.name;
  }

  getDescriptionByTariff(tariff) {
    if (!this.useTariffDescription) {
      return null;
    }

    return tariff.description || null;
  }

  getSubscriptionByTariff(tariff) {
    if (!this.useSubscription) {
      return null;
    }

    return {
      id: tariff.id,
      per: tariff.getPer(),
      oneTimePayment: tariff.oneTimePayment,
      trialDays: this.getSubscriptionTrialDays(tariff),
    };
  }

  getSubscriptionTrialDays(tariff) {
    if (!tariff.useTrialDays) {
      return null;
    }

    if (tariff.getPer() === 'SELECTIVELY') {
      return null;
    }

    if (tariff.oneTimePayment) {
      return null;
    }

    return parseInt(tariff.trialDays) || null;
  }
}

export default TariffForm;
